import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 19 18"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.125}
      d="M12.125 2.25h.375v0c1.329 0 2.493.89 2.842 2.17l.933 3.422c.105.386.158.58.202.771a9 9 0 0 1 .04 3.784c-.04.193-.088.387-.185.776v0c-.116.462-.174.693-.248.893a3.75 3.75 0 0 1-3.087 2.41c-.212.024-.45.024-.927.024H6.93c-.477 0-.715 0-.927-.024a3.75 3.75 0 0 1-3.087-2.41c-.074-.2-.132-.43-.248-.893v0a18.8 18.8 0 0 1-.185-.776 9 9 0 0 1 .04-3.784c.044-.192.097-.385.202-.771l.933-3.421A2.946 2.946 0 0 1 6.5 2.25v0h.375m-4.5 8.25h2.09c.47 0 .705 0 .918.065a1.5 1.5 0 0 1 .517.276c.172.142.302.337.563.728l.075.112c.26.391.39.586.562.728a1.5 1.5 0 0 0 .517.276c.213.065.448.065.918.065h1.93c.47 0 .705 0 .918-.065a1.5 1.5 0 0 0 .517-.276c.172-.142.302-.337.563-.728l.075-.112c.26-.391.39-.586.562-.728a1.5 1.5 0 0 1 .517-.276c.213-.065.448-.065.917-.065h2.091M9.5 8.25 11.75 6M9.5 8.25 7.25 6M9.5 8.25V1.5"
    />
  </svg>
)
export default SvgComponent
